import { render, staticRenderFns } from "./OtpHandler.vue?vue&type=template&id=965d1744"
import script from "./OtpHandler.vue?vue&type=script&lang=js"
export * from "./OtpHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports